import { FormControl, MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';
import { producaov2 } from '../../../../services/apis';
import { toast } from 'react-toastify';
import { PROJECT_APPLICATIONS_STATUS } from '../hooks/useProjectApplications';

export const gradeOptions = [
  {
    key: '-',
    value: '-'
  },
  {
    key: 'A',
    value: 'A'
  },
  {
    key: 'B',
    value: 'B'
  },
  {
    key: 'C',
    value: 'C'
  },
  {
    key: 'D',
    value: 'D'
  },
  {
    key: 'E',
    value: 'E'
  },
  {
    key: 'F',
    value: 'F'
  },
]

export default function GradeSelect({ projectApplicationID, defaultGrade, status }) {
  const [grade, setGrade] = useState(defaultGrade);
  const [loading, setLoading] = useState(false);

  const handelChangeGrade = async (e) => {
    setLoading(true);

    const prevGrade = grade;
    
    const newGrade = e.target.value;

    try {
      setGrade(newGrade);

      await producaov2.put(`/admin/project-applications/${projectApplicationID}`, {
        grade: newGrade,
      });

      toast.success('Nota atribuída com sucesso');
    } catch (error) {
      toast.error('Houve um erro ao atualizar a nota');

      setGrade(prevGrade);
    } finally {
      setLoading(false);
    }
  }

  const disabledSelect = loading || ![PROJECT_APPLICATIONS_STATUS.APPROVED, PROJECT_APPLICATIONS_STATUS.FINISHED].includes(+status);

  return (
    <FormControl
      variant="outlined"
      size="small"
      disabled={disabledSelect}
    >
      <Select
        title={disabledSelect ? "Projeto precisa estar aprovado para poder dar nota" : "Nota do aluno"}
        value={grade}
        onChange={handelChangeGrade}
      >
        {gradeOptions.map(grade => {
          return <MenuItem value={grade.key}>{grade.value}</MenuItem>
        })}
      </Select>
    </FormControl> 
  );
}